module.exports = __webpack_public_path__ + "static/img/qrcode.6194a7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/research/qrcode.png
// module id = ZKbC
// module chunks = 1